module.exports = {
  path: ':idDevice',
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/replace'),
        require('./routes/slaves'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationDevicesShow'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/configuration/routes/devices/routes/show/index.js